import React from 'react';
import { useAuth } from 'lib/context';
import { ILandingPageDesignResponse } from '../../../types';
import { useTheme } from 'styled-components/macro';
import { getHeaderLabels } from '../components/Header';
import { HeaderContainer, Label, LabelContainer, LogoImage } from './styles';
import { Flex } from 'lib/components/styles/layout';

interface IHeaderProps {
  landingPageDesign: ILandingPageDesignResponse;
}

export const Header = ({ landingPageDesign }: IHeaderProps) => {
  const theme = useTheme();
  const { userData } = useAuth();
  const {
    headerBackgroundColor,
    showHeaderShadow,
    headerLogo,
    headerContentOrientation,
    headerContentAlignment,
    showContactIcons,
    headerFontWeight,
    headerFontFamily,
    headerTextColor,
    headerFontCase,
  } = landingPageDesign;

  const color = headerTextColor || theme.colors.neutral[100];
  const headerLabels = getHeaderLabels(userData, landingPageDesign, color, 3);

  return (
    <HeaderContainer
      headerBackgroundColor={headerBackgroundColor}
      showHeaderShadow={showHeaderShadow}
    >
      {headerLogo && <LogoImage src={headerLogo} />}
      <LabelContainer
        headerContentOrientation={headerContentOrientation}
        headerContentAlignment={headerContentAlignment}
      >
        {headerLabels.map(
          (label, idx) =>
            Boolean(label.show) && (
              <Flex
                key={idx}
                flexDirection='row'
                gap='2px'
                alignItems='center'
                width='auto'
              >
                {!!showContactIcons && label.icon}
                <Label
                  color={color}
                  headerFontCase={headerFontCase}
                  headerFontWeight={headerFontWeight}
                  headerFontFamily={headerFontFamily}
                >
                  {label.text}
                </Label>
              </Flex>
            )
        )}
      </LabelContainer>
    </HeaderContainer>
  );
};
